<mat-form-field>
  <mat-label>{{ label() }}</mat-label>
  <input matInput [inputMask]="priceInputMask" [formControl]="control()" />
  @if (control().hasError('required')) {
    <mat-error>Feltet er påkrævet</mat-error>
  }
  @if (control().hasError('min')) {
    <mat-error>Pris skal være et positivt beløb</mat-error>
  }
  @if (control().hasError('max')) {
    <mat-error>Pris må ikke overskride {{ maxPrice() }}</mat-error>
  }
  @if (customError() && control().hasError(customError()!.errorKey)) {
    <mat-error>{{ customError()?.message }}</mat-error>
  }
  <ng-content />
  @if (hint()) {
    <mat-hint>{{ hint() }}</mat-hint>
  }
  <span matTextSuffix>kr.</span>
</mat-form-field>
